import { createRequestTypes } from '../utils';

export const PRODUCT_PHRASE_TR_LIST_FOR_PRODUCT = createRequestTypes('productPhraseTR/PRODUCT_PHRASE_TR_LIST_FOR_PRODUCT');
export const SAVE_PRODUCT_PHRASE_TR = createRequestTypes('productPhraseTR/SAVE_PRODUCT_PHRASE_TR');
